var _a;
import { createSlice } from "@reduxjs/toolkit";
import { MenuItem, UnitSystem, ChecklistItemName, } from "./types";
import { CameraViewId } from "3d/types";
import { USE_LOCAL_GRAPH_DATA, hasClosedChartStorageKey, } from "ui/components/panels/graphs/constants";
export var initialState = {
    cameraViewId: CameraViewId.EDIT_VIEW,
    unitSystem: UnitSystem.METRIC,
    activeMenuItem: null,
    is3DLoading: false,
    isGraphPanelOpen: USE_LOCAL_GRAPH_DATA ? true : false,
    checklist: (_a = {},
        _a[ChecklistItemName.ADD_GRIP_POSITION] = {
            translationKey: "checklist.add_grip_position",
            completed: false,
        },
        _a[ChecklistItemName.SELECT_CUP] = {
            translationKey: "checklist.select_cup",
            completed: false,
        },
        _a[ChecklistItemName.ADD_PUMP] = {
            translationKey: "checklist.add_pump",
            completed: false,
        },
        _a[ChecklistItemName.ADD_TUBE_CONNECTION] = {
            translationKey: "checklist.add_tube_connection",
            completed: false,
        },
        _a[ChecklistItemName.CONNECT_PARTS] = {
            translationKey: "checklist.connect_parts",
            completed: false,
        },
        _a[ChecklistItemName.CALCULATE] = {
            translationKey: "checklist.calculate",
            completed: false,
        },
        _a),
    selectedIds: [],
    draggedAttachmentId: null,
    hoveredAttachmentId: null,
    hasPendingSanityCheck: true,
};
var setDraggedAttachmentId = function (state, action) {
    state.draggedAttachmentId = action.payload;
};
var setHoveredAttachmentId = function (state, action) {
    state.hoveredAttachmentId = action.payload;
};
var setIs3DLoading = function (state, action) {
    state.is3DLoading = action.payload;
};
var selectEntity = function (state, action) {
    if (!action.payload) {
        return;
    }
    state.selectedIds = [action.payload];
    state.cameraViewId = CameraViewId.EDIT_VIEW;
    state.overlayData = undefined;
    state.activeMenuItem = MenuItem.SELECTED_ENTITY;
};
var selectNode = function (state, action) {
    if (!action.payload) {
        state.cameraViewId = CameraViewId.EDIT_VIEW;
        return;
    }
    state.selectedIds = [action.payload];
    state.cameraViewId = CameraViewId.NODE_OVERLAY_VIEW;
};
var setCameraView = function (state, action) {
    state.cameraViewId = action.payload;
};
var setUnitSystem = function (state, action) {
    state.unitSystem = action.payload;
};
var setOverlayData = function (state, action) {
    state.overlayData = action.payload;
};
var setActiveSidebarItemID = function (state, action) {
    state.activeSidebarItemID = action.payload;
};
var openMenuItem = function (state, action) {
    var goingBackFromMultiSelect = state.activeMenuItem === MenuItem.SELECTED_ENTITY &&
        action.payload === null &&
        state.selectedIds.length > 1;
    // if going back from the multi select menu after applying a filter, don't change menu item, just clear the selection filter
    if (goingBackFromMultiSelect && state.selectionFilter !== undefined) {
        state.selectionFilter = undefined;
        return;
    }
    state.activeMenuItem = action.payload;
    /* Deselect entities if user presses "back" button in menu*/
    if (!action.payload) {
        state.selectedIds = [];
        state.cameraViewId = CameraViewId.EDIT_VIEW;
    }
};
var toggleGraphPanel = function (state, action) {
    if (action.payload === false) {
        sessionStorage.setItem(hasClosedChartStorageKey, "true");
    }
    state.isGraphPanelOpen = action.payload;
};
var setChecklistItemCompleted = function (state, action) {
    var _a = action.payload, itemName = _a.itemName, completed = _a.completed;
    var itemToComplete = state.checklist[itemName];
    itemToComplete.completed = completed;
};
var setChecklistItemHidden = function (state, action) {
    var _a = action.payload, itemName = _a.itemName, hidden = _a.hidden;
    var itemToHide = state.checklist[itemName];
    itemToHide.hidden = hidden;
};
var applySelectionFilter = function (state, action) {
    state.selectionFilter = action.payload;
};
var setHasPendingSanityCheck = function (state, action) {
    state.hasPendingSanityCheck = action.payload;
};
var selectEntities = function (state, action) {
    var unique = new Set();
    action.payload.forEach(function (id) { return unique.add(id); });
    state.selectedIds = Array.from(unique);
    state.selectionFilter = undefined;
    state.cameraViewId = CameraViewId.EDIT_VIEW;
    state.activeMenuItem = MenuItem.SELECTED_ENTITY;
};
var deselectEntities = function (state) {
    state.selectedIds = [];
    state.selectionFilter = undefined;
    state.cameraViewId = CameraViewId.EDIT_VIEW;
    state.activeMenuItem = null;
};
var uiSlice = createSlice({
    name: "ui",
    initialState: initialState,
    reducers: {
        selectEntity: selectEntity,
        selectNode: selectNode,
        setCameraView: setCameraView,
        setOverlayData: setOverlayData,
        openMenuItem: openMenuItem,
        toggleGraphPanel: toggleGraphPanel,
        setIs3DLoading: setIs3DLoading,
        setUnitSystem: setUnitSystem,
        setChecklistItemCompleted: setChecklistItemCompleted,
        setChecklistItemHidden: setChecklistItemHidden,
        applySelectionFilter: applySelectionFilter,
        selectEntities: selectEntities,
        deselectEntities: deselectEntities,
        setActiveSidebarItemID: setActiveSidebarItemID,
        setDraggedAttachmentId: setDraggedAttachmentId,
        setHoveredAttachmentId: setHoveredAttachmentId,
        setHasPendingSanityCheck: setHasPendingSanityCheck,
    },
});
export var allActions = uiSlice.actions, reducer = uiSlice.reducer;
export var callableActions = {
    applySelectionFilter: allActions.applySelectionFilter,
    selectEntity: allActions.selectEntity,
    selectNode: allActions.selectNode,
    setCameraView: allActions.setCameraView,
    setOverlayData: allActions.setOverlayData,
    openMenuItem: allActions.openMenuItem,
    setIs3DLoading: allActions.setIs3DLoading,
    setUnitSystem: allActions.setUnitSystem,
    setChecklistItemCompleted: allActions.setChecklistItemCompleted,
    setChecklistItemHidden: allActions.setChecklistItemHidden,
    selectEntities: allActions.selectEntities,
    deselectEntities: allActions.deselectEntities,
    setActiveSidebarItemID: allActions.setActiveSidebarItemID,
    setDraggedAttachmentId: allActions.setDraggedAttachmentId,
    setHoveredAttachmentId: allActions.setHoveredAttachmentId,
    setHasPendingSanityCheck: allActions.setHasPendingSanityCheck,
};
export var internalActions = {
    toggleGraphPanel: allActions.toggleGraphPanel,
};
export default reducer;
